<template>
    <div class="problem">
        <div class="flex__center__center column  wrap">
            <p class="title">COMMON PROBLEM</p>
            <div class="flex__center__center">
                <span>——&emsp;</span>
                <span class="fs_38 c_1a">常见问题</span>
                <span>&emsp;——</span>
            </div>
        </div>
        <div class="img-box" @click="link">
            <img :src="carousel.img_path" alt="">
        </div>
        <div class="list">
            <div class="item" v-for="(item,index) in list" :key="index" v-link="'/Mine/ProblemDetail/'+item.id">
                <span class="fs_28 c_4d">{{item.title}}</span>
            </div>
        </div>
        <jc-list :url="'/Question/getQuestionList'" :loads="loads" @load='getList'></jc-list>
    </div>
</template>
<script>
export default {
    name: "Problem",
    data(){
        return{
            list:[],
            loads:{},
            carousel:{}
        }
    },
    methods:{
        getList (data) { 
            this.list=data;
        },
        link(){
            window.location.href=this.carousel.url;
        }
    },
    mounted(){
        this.axios.post('/wechat.php/Question/getTopData').then(
            res=>{
                if(res.data.code==1){
                    this.carousel=res.data.data.carousel[0];
                }
            }
        )
    }

}
</script>
<style scoped>
.problem{
    position: fixed;
    top: 0;
    bottom: 0;
    padding: 0 45px 30px;
    background: #fff;
    align-items: center;
    overflow: auto;
}
.title{
    font-size: 70px;
    color: #e6e6e6;
    line-height: 90px;
    font-weight:normal;
}
.img-box{
    padding: 40px 0 10px;
}
.img-box img{
    width: 660px;
    height: 260px;
}
.item{
    padding: 0 30px;
    height: 100px;
    margin-top: 10px;
    background: #f5f5f5;
    line-height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/pages/mine/Problem.vue